import * as types from "../mutationTypes"
import Planning from "../../services/planning";
let state = {
    savedRoutes: null,
    previewRoutes: null,
    bounds: null,
    error: null
}
const getters = {

    savedRoutes (state) {
        return state.savedRoutes
    },

    previewRoutes (state) {
        return state.previewRoutes
    },
    bounds (state) {
        return state.bounds
    },

    error (state) {
        return state.error
    }
}
const actions = {

    async initiatePreview({ commit }, routePlanningObject) {
        try {
            let res = await Planning.preview(routePlanningObject)
            if (res) {
                commit(types.REQUEST_GET_PLANNING_PREVIEW_ROUTES_SUCCESS, res.data)
            }
        } catch (error) {
            alert('no routes match the criteria!')
            commit(types.REQUEST_GET_PLANNING_PREVIEW_ROUTES_ERROR, error.message)
        }
    },

    async initiateSave ({ commit }, routePlanningObject) {
        try {
            let res = await Planning.save(routePlanningObject)
            if (res) {
                commit(types.REQUEST_GET_PLANNING_SAVE_ROUTES_SUCCESS, res.data)
            }
        } catch (error) {
            commit(types.REQUEST_GET_PLANNING_SAVE_ROUTES_ERROR, error.message)
        }
    },
    async setBounds({ commit }, bounds) {
        commit(types.REQUEST_PLANNING_SAVE_MAP_BOUNDS, bounds)
    }
}
const mutations = {
    [types.REQUEST_GET_PLANNING_PREVIEW_ROUTES_SUCCESS] (state, previewRoutes) {
        state.previewRoutes = previewRoutes
        state.error = null
    },
    [types.REQUEST_GET_PLANNING_PREVIEW_ROUTES_ERROR] (state, message) {
        state.previewRoutes = null
        state.error = message
    },
    [types.REQUEST_GET_PLANNING_SAVE_ROUTES_SUCCESS] (state, savedRoutes) {
        state.savedRoutes = savedRoutes
        state.error = null
    },
    [types.REQUEST_GET_PLANNING_SAVE_ROUTES_ERROR] (state, message) {
        state.savedRoutes = null
        state.error = message
    },
    [types.REQUEST_PLANNING_SAVE_MAP_BOUNDS] (state, bounds) {
        state.bounds = bounds
    }
}
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
